import { AccessService } from 'src/app/component/navigation/service/access.service';
import { DeleteServiceAdministrationCheckComponent } from './../delete-service-administration-check/delete-service-administration-check.component';
import { EditServiceAdministrationComponent } from './../edit-service-administration/edit-service-administration.component';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { timer } from 'rxjs';
import { Region } from 'src/app/model/region.model';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { PagingService } from 'src/app/service/paging.service';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { PartyServices } from '../model/party-services.model';
import { ServiceAdministrationService } from '../service/service-administration.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'search-service-administration',
    templateUrl: './search-service-administration.component.html',
    styleUrls: ['./search-service-administration.component.scss']
})
export class SearchServiceAdministrationComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();

    // Search variables
    chosenRegions: Region[] = [];

    activeServicesOnly: boolean = true;
    disabledServicesOnly: boolean = false;
    mpoServicesOnly: boolean = false;

    // Component variables
    resetField: boolean = false;

    // Table display
    displayedColumns: string[] = [
        'ADD_EDIT',
        'PARTY_SERVICE_STATUS_TYPES.TYPE',
        'REGION.CODE',
        'SERVICE_CODE',
        'FEDERAL_CODES.SERVICE_CODE',
        'SERVICE_NAME',
        'MEASURABLE_PROGRAM_OBJECTIVES.MPO_NUMBER',
        'SSDP_COMPONENTS[0].NAME',
        'PARENT_SERVICE_TYPES.TYPE',
        'SERVICE_CATEGORIES.CATEGORY',
        'GRADES_FLAT',
        'ENROLLMENT_PERIODS_FLAT'
    ];
    newDisplayedColumns: string[] = ['ADD'];

    // Table results
    tableDataSource!: MatTableDataSource<PartyServices>;

    // Results
    results: PartyServices[] = [];
    filter: string = '';

    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    currentFilter: string;

    featuresCheck = ['Create Service Administrations', 'View Service Administrations', 'Edit Service Administrations', 'Delete Service Administrations'];
    featurePermissions: any;

    constructor(
        public pagingService: PagingService,
        private dialog: MatDialog,
        private serviceAdministrationService: ServiceAdministrationService,
        private accessService: AccessService
    ) {}

    ngOnInit(): void {
        this.getFeaturePermissions();
    }

    getFeaturePermissions() {
        this.accessService.getFeatureAccessPromise(this.featuresCheck).then((res) => {
            this.featurePermissions = res;
        });
    }

    search() {
        if (this.checkValid()) {
            this.isLoading = true;
            this.msg = {};
            this.filter = '';

            this.serviceAdministrationService.index(this.generatePayload()).subscribe({
                next: (res) => {
                    if (res.partyServices) {
                        this.results = res.partyServices.sort((n1: PartyServices, n2: PartyServices) => (n1.SERVICE_NAME! > n2.SERVICE_NAME! ? 1 : -1));
                    } else if (res.msg) {
                        this.results = [];
                        this.msg = res.msg;
                    } else {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error searching Service Adminstrations.' };
                    }
                },
                error: (err) => {
                    this.results = [];
                    this.msg = { SUCCESS: false, MSG: 'Error searching Service Adminstrations.' };
                },
                complete: () => {
                    // Updates the Tables to be displayed w/ this.results
                    if (this.results.length > 0) {
                        this.updateDataSource();
                    }

                    // Display results
                    this.isLoading = false;
                }
            });
        } else {
            this.msg = { SUCCESS: false, MSG: 'Please select a Region.' };
        }
    }

    generatePayload(): any {
        let payload: any = {};

        payload.regionId = this.chosenRegions[0] ? this.chosenRegions[0].ID : undefined;
        payload.activeServicesOnly = this.activeServicesOnly;
        payload.disabledServicesOnly = this.disabledServicesOnly;
        payload.mpoServicesOnly = this.mpoServicesOnly;

        return payload;
    }

    updateDataSource() {
        setTimeout(() => {
            // Data
            this.tableDataSource = new MatTableDataSource<PartyServices>();
            this.tableDataSource.data = this.results;

            // Paginator
            this.tableDataSource.paginator = this.paginators.toArray()[0];

            // Sort
            this.tableDataSource.sort = this.sorts.toArray()[0];
            const defaultSort: Sort = { active: 'SERVICE_NAME', direction: 'asc' };
            this.tableDataSource.sort.active = defaultSort.active;
            this.tableDataSource.sort.direction = defaultSort.direction;
            this.tableDataSource.sort.sortChange.emit(defaultSort);
            this.tableDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

            // Filter
            this.tableDataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };
        });
    }

    setFilter() {
        this.tableDataSource.filter = this.filter.trim().toLocaleLowerCase();
    }

    checkValid() {
        if (this.chosenRegions.length > 0) {
            return true;
        }

        return false;
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }

    // Location Emitters
    regionEventEmitter(regions: Region[]) {
        this.chosenRegions = regions;
    }

    // MISC
    reset() {
        this.resetField = !this.resetField;
        //This is optional code To reset the value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        this.chosenRegions = [];

        this.activeServicesOnly = true;
        this.disabledServicesOnly = false;
        this.mpoServicesOnly = false;

        this.msg = {};
    }

    announceSortChange(sortState: Sort) {}

    // Dialog Modal
    openDialog(mode: string, serviceAdministrationId?: number, SERVICE_NAME?: string) {
        if (mode === 'Edit') {
            Swal.fire({
                titleText: 'Confirm Editing Service: ' + SERVICE_NAME,
                text: 'Any changes you make on this screen will apply to all historical records entered under this local code number.',
                showDenyButton: false,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Proceed',
                denyButtonText: 'Cancel',
                icon: 'warning',
                confirmButtonColor: '#3a6b35'
            }).then((result) => {
                if (result.isConfirmed) {
                    let payload: any = {};
                    payload.serviceAdministrationId = serviceAdministrationId;
                    payload.mode = mode;

                    const dialogConfig = new MatDialogConfig();
                    dialogConfig.data = payload;
                    dialogConfig.maxHeight = '99vh';
                    dialogConfig.minWidth = '90vw';
                    const dialogRef = this.dialog.open(EditServiceAdministrationComponent, dialogConfig);

                    dialogRef.afterClosed().subscribe((refresh: boolean) => {
                        if (refresh) {
                            this.getServiceAdministration(serviceAdministrationId!);
                        }
                    });
                }
            });
        } else {
            let payload: any = {};
            payload.serviceAdministrationId = serviceAdministrationId;
            payload.mode = mode;

            const dialogConfig = new MatDialogConfig();
            dialogConfig.data = payload;
            dialogConfig.maxHeight = '99vh';
            dialogConfig.minWidth = '90vw';
            const dialogRef = this.dialog.open(EditServiceAdministrationComponent, dialogConfig);

            dialogRef.afterClosed().subscribe((refresh: boolean) => {
                if (refresh) {
                    this.search();
                }
            });
        }
    }

    openDeleteDialog(serviceAdministrationId: number, SERVICE_NAME: string) {
        let payload: any = {};
        payload.serviceAdministrationId = serviceAdministrationId;
        payload.SERVICE_NAME = SERVICE_NAME;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = payload;
        const dialogRef = this.dialog.open(DeleteServiceAdministrationCheckComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((success: boolean) => {
            if (success) {
                this.search();
            }
        });
    }

    toggleActive(partyServiceID: number, SERVICE_NAME: string, currentStatus: string) {
        Swal.fire({
            titleText: 'Toggle Status: ' + SERVICE_NAME,
            text: currentStatus + ' -> ' + (currentStatus === 'Active' ? 'Inactive' : 'Active'),
            showDenyButton: false,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            denyButtonText: 'Cancel',
            confirmButtonColor: '#3a6b35'
        }).then((result) => {
            if (result.isConfirmed) {
                this.toggleStatus(partyServiceID);
            }
        });
    }

    toggleStatus(partyServiceID: number) {
        this.serviceAdministrationService.toggleStatus(partyServiceID).subscribe({
            next: (res) => {
                if (res.msg) {
                    if (res.msg.SUCCESS) {
                        this.getServiceAdministration(partyServiceID);
                    }
                }
            },
            error: (err) => {},
            complete: () => {}
        });
    }

    getServiceAdministration(partyServiceID: number) {
        this.serviceAdministrationService.show(partyServiceID).subscribe({
            next: (res) => {
                if (res.partyService) {
                    let partyServiceIndex = this.results.findIndex((res) => res.ID === partyServiceID);
                    this.results[partyServiceIndex] = res.partyService;
                }
            },
            error: (err) => {},
            complete: () => {
                this.updateDataSource();
            }
        });
    }
}
